﻿module PortalLibs.Shared.Map

open FSharpPlus

let toKeyList map =
  Map.toSeq map
  |>> fst
  |> Seq.toList

let getValues map =
  Map.toSeq map |>> snd

let toValueList map = getValues map |> Seq.toList

let addRange items map =
  Seq.fold (fun m (k, v) -> Map.add k v m) map items
  
let addIfDoesntExist key item map =
  match Map.tryFind key map with
  | None -> Map.add key item map
  | Some _ -> map

let updateIfExists key update map =
  match Map.tryFind key map with
  | None -> map
  | Some entry -> Map.add key (update entry) map

let updateOrAdd key update add map =
  match Map.tryFind key map with
  | None -> Map.add key add map
  | Some item -> Map.add key (update item) map

let iterIfExists key iter map =
  map |> Map.tryFind key |> Option.iter iter

let mergeMap one two =
  Map.fold (fun map key value -> Map.add key value map) two one

let mergeMapWithUpdateOrAdd update oldMap newMap =
  Map.fold (fun map key value -> updateOrAdd key update value map) oldMap newMap

let mergeMapWithUpdate2OrAdd update oldMap newMap =
  Map.fold (fun map key value -> updateOrAdd key (update value) value map) oldMap newMap

let mergeMapWithUpdateIfExists update oldMap newMap =
  Map.fold (fun map key value -> updateIfExists key (update value) map) oldMap newMap

let mergeMapOpt one twoOpt =
  match twoOpt with
  | None -> Some one
  | Some map -> Some(mergeMap one map)
